<template>
  <el-row style="margin-top: 50vh; font-size: 20px;">
    <el-col
      :span="14"
      :offset="6"
      style="height: 100px; background-color: gainsboro;"
      class="tip-content"
    >
      <div style="text-align: center;font-size: 3rem;">
        功能开发中，暂不支持手机端
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {},

  computed: {},
};
</script>

<style lang="scss" scoped>
.tip-content {
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中，如果需要的话 */
  height: 100vh;
}
</style>
